import * as React from 'react';
var InfoBarMessageWithCustomAction = function (props) {
    var customActionClickHandler = function (action) {
        return function (evt) {
            evt.stopPropagation();
            action();
        };
    };
    return (React.createElement("a", { className: props.className, onClick: customActionClickHandler(props.customAction.action) }, props.customAction.text));
};
export default InfoBarMessageWithCustomAction;
//# sourceMappingURL=InfoBarMessageWithCustomAction.js.map